export function LiveFeed() {
  return (
    <div className="w-screen shrink-0 px-4 sm:px-8 fade-in" data-testid="live-feed">
      <div
        className="w-full aspect-video max-h-[60vh] mx-auto flex flex-col items-center justify-center relative"
        style={{ border: "1px solid var(--border)", background: "#0a0a0a" }}
        data-testid="live-feed-box"
      >
        <div className="absolute top-4 left-4 flex items-center gap-2 text-xs tracking-widest" style={{ color: "var(--text-muted)" }} data-testid="live-feed-status">
          <span className="inline-block w-2 h-2 rounded-full" style={{ background: "var(--text-muted)" }} />
          offline
        </div>
        <p className="font-head text-lg sm:text-2xl tracking-widest" style={{ color: "var(--text-secondary)" }} data-testid="live-feed-message">feed not yet connected</p>
      </div>
    </div>
  );
}
